// language=GLSL
export const glslHash = `
#ifndef GLSL_HASH
#define GLSL_HASH
float hash(float n) {
    return fract(sin(n) * 43758.5453123);
}
#endif
`;